export default __webpack_public_path__ + "static/1404-56e008af3d9b4ae5775f2c6fda75468c.gif";